<template>
    <div class="language-switcher">
        <button
            class="btn btn-primary dropdown-toggle btn-language-switch"
            type="button"
            data-toggle="dropdown"
            aria-expanded="false">
            <img
                :src="currentLocale.flag"
                :alt="`${currentLocale.name} flag`" />
        </button>

        <div class="dropdown-menu dropdown-menu-right language-menu">
            <a
                class="dropdown-item language-item"
                v-for="locale in locales"
                :key="locale.locale"
                :href="routes.setUserLocale(locale.code)"
                role="button">
                <img
                    :src="locale.flag"
                    :alt="`${locale.name} flag`" />{{ locale.name }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-dashboard-language-select-component',
    data() {
        const locales = [
            {
                code: 'nl',
                name: 'Nederlands',
                flag: '/images/flags/nl-flag.png',
            },
            {
                code: 'en',
                name: 'English',
                flag: '/images/flags/uk-flag.png',
            },
        ];
        return {
            locales: locales,
            currentLocale: locales.find((locale) => locale.code === this.$authUser.locale) ?? locales[0],
        };
    },
};
</script>

<style scoped lang="scss">
.btn-language-switch.btn-language-switch {
    color: $white;
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
    padding: map-get($grid-gutter-spacing, 'eight');

    img {
        width: 20px;
        height: 13px;
        margin-right: map-get($grid-gutter-spacing, 'four');
    }

    &,
    &:hover,
    &:active,
    &:focus,
    &:not(:disabled):not(.disabled):active {
        background-color: transparent;
        border: none;
    }
}

.language-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: map-get($grid-gutter-spacing, 'eight');
    column-gap: map-get($grid-gutter-spacing, 'eight');
    font-size: $default-font-size;

    img {
        width: 20px;
        height: 13px;
    }

    &:hover {
        color: $white;
        background-color: $primary;
    }
}
</style>
